import { render, staticRenderFns } from "./DeckComments.vue?vue&type=template&id=74070432&"
import script from "./DeckComments.vue?vue&type=script&lang=js&"
export * from "./DeckComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports